import { updateValueExtender } from '_/extenders/updateValueExtender';

/**
 * Action to update field values using passed arguments
 *
 * @param   {function}  options.commit
 * @param   {string}  mutation
 * @param   {integer}  id
 * @param   {string}  name
 * @param   {object}  newValue
 * @return  {void}
 */
export const updateValue = ({ dispatch, commit }, mutation, id, name, value) => {
    commit(mutation, { id, name, newValue: value });
    updateValueExtender({ dispatch, commit }, id, name, value);
};
